import RoomPreview from './RoomPreview';

export default RoomPreview;
